/*
 * Copyright (c) 2020 JCA Electronics , Winnipeg, MB. All rights reserved.
 */
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { FieldOperationsModel } from '@/flightpath-components/models/FieldOperationsModel';
import { SortHelper } from '@/services/SortHelper';
import { Point } from '@/flightpath-components/models/Point';
import { GPSLocation } from '@/flightpath-components/models/GPSLocation';

@Module({ name: 'fields' })
export default class FieldStore extends VuexModule {
  // there are 10000 meters squared per hectare
  m2ToHectaresFactor = 10000;

  private fields: FieldOperationsModel[] = [];
  private field: FieldOperationsModel | null = null;
  private fieldArea = 9;
  private editMode = false;
  private addMode = false;
  private clearFieldMap = false;
  private currentPolygon: google.maps.LatLng[] = [];
  private revertBoundary = false;
  public insertNewPolygon = false;

  @Mutation
  setFields(fields: FieldOperationsModel[]) {
    this.fields = fields.sort((a, b) => SortHelper.compareStrings(a.FieldName as string, b.FieldName as string));
  }
  @Mutation
  setSelectedField(field: FieldOperationsModel) {
    this.field = field;
  }
  @Mutation
  toggleEditMode() {
    this.editMode = !this.editMode;
  }
  @Mutation
  toggleAddMode() {
    this.addMode = !this.addMode;
  }
  @Mutation
  setSelectedFieldArea(area: number) {
    this.fieldArea = Math.round(area);
  }
  @Mutation
  triggerClearFieldMap() {
    this.clearFieldMap = !this.clearFieldMap;
  }
  @Mutation
  updateCurrentPolygon(polygon: google.maps.Polygon) {
    this.currentPolygon = polygon.getPath().getArray();
  }
  @Mutation
  setPathToPolygon(newPath: google.maps.LatLng[]) {
    this.currentPolygon = newPath;
    this.insertNewPolygon = !this.insertNewPolygon;
  }
  @Mutation
  setBoundary(newBoundary: GPSLocation[]) {
    if(this.field != undefined && this.field != null){
      this.field.BoundaryPoints = newBoundary
      .map((point) => {
        return { Item1: point.Latitude, Item2: point.Longitude} as Point;
      });
    }
  }
  @Mutation
  triggerRevertBoundary() {
    this.revertBoundary = !this.revertBoundary;
  }

  get availableFields() {
    return this.fields;
  }
  get selectedField() {
    return this.field;
  }
  get editFieldMode() {
    return this.editMode;
  }
  get addFieldMode() {
    return this.addMode;
  }
  get selectedFieldArea() {
    return this.fieldArea;
  }
  get polygon() {
    return this.currentPolygon;
  }
  get selectedFieldAreaHectares() {
    return this.fieldArea / this.m2ToHectaresFactor;
  }
}
